import LoginScreen from './LoginScreen';

type LoginScreenContainerProps = {};

const LoginScreenContainer: React.FC<LoginScreenContainerProps> = (props) => {
	return <LoginScreen />;
};

export default LoginScreenContainer;
